import React from 'react'

// Deleted roles are hidden by default; this surfaces them for history.
function DeletedRolesToggle({ params, setParams }) {
  return (
    <div className="form-check form-switch mt-1">
      <input
        className="form-check-input"
        type="checkbox"
        id="showDeleted"
        checked={!!params.showDeleted}
        onChange={() => setParams({ ...params, showDeleted: !params.showDeleted })}
      />
      <label className="form-check-label" htmlFor="showDeleted">
        Show Deleted
      </label>
    </div>
  )
}

export default DeletedRolesToggle
